import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BatchEventsManager } from "@faire/web--source/common/batch-events/BatchEventsManager";
import { createRecordClientEventRequest } from "@faire/web--source/common/events/createRecordClientEventRequest";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
/**
 * Delegate for all generated PETE event utils, which handles the various schema configurations.
 */
export var trackClientEvent = function trackClientEvent(params) {
  var _getGlobalProperty;
  var _createRecordClientEv = createRecordClientEventRequest(params),
    request = _createRecordClientEv.request,
    currentEventTime = _createRecordClientEv.currentEventTime;
  BatchEventsManager.get().enqueueEvent(request);
  var trackedEvent = _objectSpread(_objectSpread({}, params), {}, {
    eventId: request.event_id
  });
  (_getGlobalProperty = getGlobalProperty("faire.events.interceptors")) === null || _getGlobalProperty === void 0 ? void 0 : _getGlobalProperty.forEach(function (i) {
    return i(trackedEvent);
  });
  return {
    sourceEventHash: request.source_event_hash,
    sourceEventKey: params.eventKey,
    sourceEventStart: currentEventTime
  };
};